// extracted by mini-css-extract-plugin
export default {"panelRow":"PanelRow_panelRow__jpVWU"};